// CreateOrder.jsx
import React, { useState } from 'react';
import api from '../Service/api'; // your axios instance
import './CreateOrder.css';

const CreateOrder = () => {
  const [formData, setFormData] = useState({
    companyName: '',
    productName: '',
    quantity: '',
    customerName: '',
    requirement: '',
  });
  const [message, setMessage] = useState('');

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await api.post('/api/orders', formData);
      setMessage('Order created successfully!');
      setFormData({
        companyName: '',
        productName: '',
        quantity: '',
        customerName: '',
        requirement: ''
      });
      setTimeout(() => setMessage(''), 3000);
    } catch (error) {
      setMessage('Error creating order: ' + (error.response?.data || error.message));
    }
  };

  return (
    <div className="create-order-container">
      <h2 className="create-order-title">Create New Order</h2>
      
      {message && (
        <div className={`create-order-message ${message.includes('Error') ? 'error' : 'success'}`}>
          {message}
        </div>
      )}

      <form onSubmit={handleSubmit} className="create-order-form">
        <div className="create-order-form-group">
          <label className="create-order-label">Company Name</label>
          <input
            type="text"
            name="companyName"
            value={formData.companyName}
            onChange={handleChange}
            required
            className="create-order-input"
            placeholder="Enter company name"
          />
        </div>

        <div className="create-order-form-group">
          <label className="create-order-label">Product Name</label>
          <input
            type="text"
            name="productName"
            value={formData.productName}
            onChange={handleChange}
            required
            className="create-order-input"
            placeholder="Enter product name"
          />
        </div>

        <div className="create-order-form-group">
          <label className="create-order-label">Quantity</label>
          <input
            type="number"
            name="quantity"
            value={formData.quantity}
            onChange={handleChange}
            required
            min="1"
            className="create-order-input"
            placeholder="Enter quantity"
          />
        </div>

        <div className="create-order-form-group">
          <label className="create-order-label">Customer Name</label>
          <input
            type="text"
            name="customerName"
            value={formData.customerName}
            onChange={handleChange}
            required
            className="create-order-input"
            placeholder="Enter customer name"
          />
        </div>

        <div className="create-order-form-group">
          <label className="create-order-label">Requirement</label>
          <input
            type="text"
            name="requirement"
            value={formData.requirement}
            onChange={handleChange}
            required
            className="create-order-input"
            placeholder="Enter customer requirement"
          />
        </div>

        <button type="submit" className="create-order-submit-btn">
          Create Order
        </button>
      </form>
    </div>
  );
};

export default CreateOrder;